import { render } from "./HeaderLayout.vue?vue&type=template&id=afc45c40&scoped=true"
import script from "./HeaderLayout.vue?vue&type=script&lang=js"
export * from "./HeaderLayout.vue?vue&type=script&lang=js"

import "./HeaderLayout.vue?vue&type=style&index=0&id=afc45c40&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/生产环境/M平台/前端/servicepartner.matchupexpo.com - 外呼合作方端/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afc45c40"]])

export default __exports__